<template>
    <div class="status-filter">
        <!-- Selected Statuses Display -->
        <div v-if="localSelectedStatusNames && localSelectedStatusNames.length > 0" class="selected-statuses-list mb-3">
            <div class="selected-items">
                <div
                    v-for="statusName in localSelectedStatusNames"
                    :key="`selected-${statusName}`"
                    class="unified-filter-row"
                >
                    <span class="filter-content-text">{{ statusName }}</span>
                    <div style="margin-left: auto;">
                        <button
                            class="remove-filter-button-fixed"
                            :aria-label="`Remove ${statusName} filter`"
                            @click.stop="removeStatusFromFilter(statusName, filter)"
                        >
                            <e-icon icon="times" size="is-small" />
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Available Statuses List -->
        <div :key="`available-statuses-${(filter.value || []).join('-')}`" class="available-statuses-list">
            <div class="available-items available-items-container">
                <div
                    v-if="availableStatuses.length === 0"
                    class="unified-filter-row"
                >
                    <span class="filter-content-text">All statuses are selected</span>
                </div>
                <div
                    v-for="(status, index) in availableStatuses"
                    :key="`available-status-${status.name}-${index}`"
                    class="unified-filter-row clickable-item"
                    :class="{ 'has-border-bottom': index < availableStatuses.length - 1 }"
                    @click.stop="addStatusToFilter(status.name, filter)"
                >
                    <e-checkbox
                        :value="false"
                        size="is-small"
                        @click.stop="addStatusToFilter(status.name, filter)"
                    />
                    <span class="filter-content-text">
                        {{ status.name }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatusFilterItem',

    props: {
        filter: {
            type: Object,
            required: true,
        },
        availableStatuses: {
            type: Array,
            required: true,
        },
        localSelectedStatusNames: {
            type: Array,
            required: true,
        },
        addStatusToFilter: {
            type: Function,
            required: true,
        },
        removeStatusFromFilter: {
            type: Function,
            required: true,
        },
    },
};
</script>

<style scoped>
/* Status filter specific styles */
.status-filter {
    width: 100%;
}

.selected-items {
    margin-bottom: 8px;
}

.available-items-container {
    background: var(--scheme-main);
}

.has-border-bottom {
    border-bottom: 1px solid var(--border);
}

.clickable-item {
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.clickable-item:hover {
    background-color: var(--scheme-main-bis) !important;
}


.unified-filter-row {
    display: flex;
    padding: 7.2px 14.4px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}

.filter-content-text {
    color: var(--text);
    font-family: Stolzl;
    font-size: 13.68px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

.remove-filter-button-fixed {
    border: none !important;
    background: transparent !important;
    color: #666 !important;
    padding: 2px !important;
    height: auto !important;
    min-height: auto !important;
    line-height: 1 !important;
    cursor: pointer;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.mb-3 {
    margin-bottom: 1rem;
}
</style>
